module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "sec-23"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "1. RUSH"
    }
  }, [_c('h1', {
    staticClass: "chapter1",
    attrs: {
      "id": "pz15-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/contenttoc#BB_2",
      "id": "AA_2"
    }
  }, [_vm._v("1 "), _c('br'), _c('br'), _c('b', [_vm._v("RUSH")]), _vm._v(" "), _c('br'), _c('br'), _c('em', [_c('span', {
    staticClass: "center",
    attrs: {
      "id": "pz15-3"
    }
  }, [_vm._v("Less Rush, More Rhythm")])])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz15-4"
    }
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("H")]), _vm._v("ave you ever wondered when life began to be different? When did we change from happy little girls to frenzied women—perhaps even becoming frenzied moms of happy little girls? Where was that crossover? That time marked by stepping with one foot from the age of happiness and ease "), _c('em', [_vm._v("into")]), _vm._v(" the age of stress. Was it a specific birthday? Is there a mark on our time lines when we changed from carefree little girls into frazzled grown-up girls? Or was it a gradual shift in life and perspective that occured over the span of years, life events, and change?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz15-5"
    }
  }, [_vm._v("Somewhere along the way, we went from thriving to surviving, from being full of joy to being full of stress. I believe this change starts to take place as we add commitments and "), _c('span', {
    attrs: {
      "id": "z16-1"
    }
  }, [_vm._v("responsibilities to our plates, never stopping to reevaluate or subtract as our plate begins to feel full. And as we rush to keep up with our overfull lives, we paradoxically begin to feel empty.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-2"
    }
  }, [_vm._v("This empty feeling has a lot of names: "), _c('em', [_vm._v("overwhelmed")]), _vm._v(", "), _c('em', [_vm._v("stressed")]), _vm._v(", "), _c('em', [_vm._v("frazzled")]), _vm._v(", "), _c('em', [_vm._v("frenzied")]), _vm._v(", and "), _c('em', [_vm._v("frantic")]), _vm._v(". While many treacherous and tragic things can cause us to feel this way, I want to dig into the idea of "), _c('em', [_vm._v("everyday empty")]), _vm._v(": a state of being that happens when the enormity and momentum of everyday life begins to take over, taking up any space that could be left over for fun or joy.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "hang1",
    attrs: {
      "id": "pA24"
    }
  }, [_c('em', [_vm._v("Somewhere along the way, we went from thriving to surviving, from being full of joy to being full of stress.")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-5"
    }
  }, [_vm._v("Many times, we allow our lives to continue at this pace because we are afraid to acknowledge the way we’re feeling. We feel guilty for feeling anything but happy or grateful.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-6"
    }
  }, [_vm._v("“Who am I to feel overwhelmed and empty when my basic needs are met—and then some?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-7"
    }
  }, [_vm._v("“Who am I to feel stressed and frazzled when I have healthy children or am cancer-free or am not dealing with XYZ like my neighbor or friend is?”")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz16-10"
    }
  }, [_vm._v("I’ve often shoved this empty feeling down into the corners of my heart because of the guilt that comes with acknowledging it. It feels as if, by acknowledging the overwhelm, I am devoid of gratitude for the blessings, privileges, and treasures "), _c('span', {
    attrs: {
      "id": "z17-1"
    }
  }, [_vm._v("in my life. So instead of identifying the problem and finding a solution, I have turned the other way and ignored the feelings, allowing them to fester and grow. This inevitably leads to a crash-and-burn scenario.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-2"
    }
  }, [_vm._v("This large-scale burnout I feel so personally and see all around me is a tragedy and, quite honestly, a uniquely female epidemic. Our world is so much different than it was even five or ten years ago. My own mom marvels at what’s been heaped onto the plates of young women today, including alarmingly busy schedules, social media, and constant connection through smartphones. The internet wasn’t even around when my mom was in her thirties. The world is dramatically different, and I fear that we haven’t done enough to prepare women to adapt along the way.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz17-3"
    }
  }, [_vm._v("Were we created to be pulled in this many directions, to be this “on” all the time? I certainly don’t feel like I have the capacity for it all. And I know for sure that when I’m living life stretched this thin, I’m missing so much goodness along the way. "), _c('em', [_vm._v("That")]), _vm._v(" is the truest tragedy of this epidemic: the little ones rushed from activity to activity, the comforting routines of home life constantly interrupted by frenzied attitudes or rigorous schedules, and missing out on the true treasures of life found in ordinary moments—slow bedtime conversations with a toddler’s head on the pillow next to yours, the way the sun sends golden rays through a big oak tree just before sunset, or the taste of crunchy buttered bread dipped into slow-cooked "), _c('span', {
    attrs: {
      "id": "z18-1"
    }
  }, [_vm._v("soup, made with love by hands that cared for your very first bite. Oh, what we miss when we rush through life.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_01",
      "role": "doc-chapter",
      "title": "THE PARADOX OF EVERYDAY EMPTY"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz18-2"
    }
  }, [_c('b', [_vm._v("THE PARADOX OF EVERYDAY EMPTY")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz18-3"
    }
  }, [_vm._v("Imagine that your life is a bright yellow balloon. As young girls, our balloons are adequately full of responsibilities, allowing space for joy. But as we get older, the balloons begin to change. It’s not a slow leak that steals our joy. Instead, little by little, we add seemingly "), _c('em', [_vm._v("good")]), _vm._v(" things into it—one after the other. One more puff of air, followed by another and another. Job. "), _c('em', [_vm._v("Jobs")]), _vm._v(". Marriage. A child. Children. Church. Volunteer projects. Social events. Social media. Phone calls. Text messages. Household chores. Mortgages. Soccer practice. Play practice. Tutoring. Meal planning.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-4"
    }
  }, [_vm._v("A little puff. Followed by another little puff. Followed by just one more puff. Eventually, what happens?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-5"
    }
  }, [_vm._v("At some point, the balloon either outright pops or it just barely holds, stretched taut, to its absolute maximum capacity. That “balloon” has become unfathomably fragile, susceptible to everything around it, ready to burst at a moment’s notice. "), _c('em', [_vm._v("This")]), _vm._v(" is the paradox of everyday empty: a life filled to capacity with commitments, possessions, communications, and connections that is deceivingly full but soulfully and spiritually empty.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz18-6"
    }
  }, [_vm._v("There is life beyond this. I challenge you to set aside "), _c('span', {
    attrs: {
      "id": "z19-1"
    }
  }, [_vm._v("everything you know or believe about pouring out and filling up, about overwhelm and emptiness. Set aside the lies that self-care ends at a manicure and that the perfect organizer will instantly bring order to your overwhelm (yes, I just said that—and I make planners for a living). Becoming the girls God made us to be requires the tedious, difficult work of undoing, unbecoming, and unlearning until we are at our absolute basic self, then rebuilding, replenishing, and refueling our minds, bodies, and souls.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz19-2"
    }
  }, [_vm._v("Oh, what the world could be if we all became those joyful, energized girls we once were.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_02",
      "role": "doc-chapter",
      "title": "BEAUTY IN STILLNESS"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz19-3"
    }
  }, [_c('b', [_vm._v("BEAUTY IN STILLNESS")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz19-4"
    }
  }, [_vm._v("One December, in the middle of a very busy season of parenting and work, I took a business trip to Ohio. I knew it would be cold, but to my dismay, the weather forecast didn’t call for any snow while we were visiting. I was bummed. At thirty-five, I had never witnessed an actual snowfall. I’d seen some light snow flurries and even a few snowflakes on a trip to North Carolina one time, but I desperately wanted to see white-blanket, winter wonderland–style snow. My travel companions had either lived in parts of the country that get snow or traveled previously to snowy destinations, so they weren’t exactly on board with my snow-filled dreams.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-2"
    }
  }, [_vm._v("Our first day was dreadfully cold and full of nonstop meetings, but we eventually turned in for the night at our hotel—exhausted and ready for rest. The next morning, much to my surprise, I pulled back the heavy blackout curtain to reveal the most beautiful Holiday Inn Express parking lot I had ever seen. It might as well have been Santa’s workshop at the North Pole. It was glorious. Every car two floors below was covered in a thick layer of fresh, white snow. Out past the parking lot, the townhomes nearby were glazed with untouched powder as well. I squealed and immediately FaceTimed my kids to show them the beautiful scene.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-3"
    }
  }, [_vm._v("I marveled at my first steps in the snow that morning as we all tromped to the car, surprised by how dry and fluffy the snow felt squeaking and crunching beneath my boots. When my coworkers and I got in the car, they remarked at how funny it was to watch me experience snow for the first time. They said I was like a little girl! And honestly, I felt that way. I can only describe my first snowfall as absolutely mesmerizing. For just a few minutes, the busyness and rush of our trip and all that comes along with leaving children at home faded away.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz20-4"
    }
  }, [_vm._v("We drove through rural Ohio to the offices where we had meetings for the day. The snow was unexpected, so the entire town was quiet. As we twisted and turned through neighborhood after neighborhood, I couldn’t help but marvel at the stillness of the morning. There were nearly no cars on the "), _c('span', {
    attrs: {
      "id": "z22-1"
    }
  }, [_vm._v("roads, and everything felt strangely silent in some inexplicably beautiful, all-encompassing way I’d never experienced before. Every tree along the way—big, small, old, new, thick, thin, bearing thousands of leaves or none at all—was perfectly still and had been softly and purposefully kissed by the snow. The beautiful white flakes lay thick and still on every tiny and enormous branch, making the entire scene absolutely magical.")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pAJQ"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "AJQ",
      "role": "presentation",
      "src": "images/himg-21-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "center1",
    attrs: {
      "id": "pAj8"
    }
  }, [_c('em', [_vm._v("I deeply, desperately, and quietly wanted God to replenish me.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-2"
    }
  }, [_vm._v("God didn’t forget about a single tree that morning. It was as if He quieted the rush of the whole world to show us how much beauty can be found in stillness. He identified each and every tree, calling each one by name, and gave each majestic branch and miniscule twig its brief moment of glory as pure white snow was carefully and meticulously placed on it. I’d been feeling especially frenzied (after a cross-state move and busy days at work) and fought back tears at the thought that God hadn’t forgotten me either. I didn’t have a specific prayer I’d been hoping God would answer (other than for Him to bring snow, of course), but I deeply, desperately, and quietly wanted God to replenish me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz22-3"
    }
  }, [_vm._v("And so, God sent the snow. It was a reminder that God sees me, He knows my heart, and He knows exactly what I need. He knew that the quiet, magical snowfall—the brief escape from the rush—would be a balm to my tired heart and would remind me of how much joy can be found in stillness. In His own surprising, wonderful, snowy way, He reminded me of who I am (and Whose I am) and that the rush isn’t worth it.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_03",
      "role": "doc-chapter",
      "title": "ENOUGH IS ENOUGH"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz23-1"
    }
  }, [_c('b', [_vm._v("ENOUGH IS ENOUGH")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz23-2"
    }
  }, [_vm._v("Alabama has this song that always strikes a chord with me when I hear it. One particular lyric—about rushing to the point of life no longer being fun—is especially accurate. In my experience, that’s exactly where rushing (to keep up with everything on my plate) takes me—to a not-so-happy place. Typically, this is a cyclical occurrence, the rush building up both quickly and slowly after intentional periods of calm, eventually pushing me to a breaking point.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-3"
    }
  }, [_vm._v("Rinse.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-4"
    }
  }, [_vm._v("Repeat.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-5"
    }
  }, [_vm._v("Each time this would happen, I’d rework a few things in our lives, tinker with schedules and routines, and inevitably get back to rushing, hoping my solutions would permanently fix the problem.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-6"
    }
  }, [_vm._v("I’m considered an expert on simplifying—I’ve even written books on the topic. But what I’ve noticed, with more years under my belt of strategizing techniques to automate, simplify, and organize the busyness of life, is that a deeper problem is at play in our frenetic, fever-pitched pace each day. A societal “way of life” has slowly crept in and become the norm. We can keep pausing the hamster wheel we’re on to catch our breaths, but eventually we’re going to have to step off.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz23-7"
    }
  }, [_vm._v("While the tactics of simplifying daily life and organizing our time are incredibly valuable and life-changing, this insidious "), _c('span', {
    attrs: {
      "id": "z24-1"
    }
  }, [_vm._v("underlying epidemic bubbling just beneath the surface of our lives has caused them to fall out of sync and has bred burnout, stress, and emptiness.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-2"
    }
  }, [_vm._v("So . . . what if we said enough is enough? What if we decided to live life our own way? What if we stopped racing toward this imaginary finish line? Could we walk instead? Could we settle in to where we are right now, acknowledge that “right now” is pretty good, and savor all we have to be grateful for? Even more important, could we proclaim that constantly pushing for “great” might not be worth the price we pay? What if, individually, we decided to take our lives back?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-3"
    }
  }, [_vm._v("And what if we changed everything?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-4"
    }
  }, [_vm._v("Our lives are so full, and yet many of us feel so empty. This paradox has confused me. If my life is full of good things, shouldn’t I also "), _c('em', [_vm._v("feel")]), _vm._v(" full, whole, and joyful? Could it be that our lives are actually just "), _c('em', [_vm._v("too")]), _vm._v(" full? And that everything needs to be questioned? That perhaps there’s a better or different way to live?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz24-5"
    }
  }, [_vm._v("I began to wonder if less of everything might be the key. Maybe the world was wrong; maybe I could approach the rush and frenzy of our lives with the same tactics I used to organize and simplify spaces and schedules. When organizing a kitchen drawer, for example, you first declutter—by handling each item, evaluating it, and keeping only the best, favorite, and necessary. Then, once you’ve pared down to the essentials (the keepers), you add organization to it, such as a drawer divider or a system for sorting.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-1"
    }
  }, [_vm._v("Life is the same way. We must first unpack our commitments, evaluate each one, and make a decision: keep the nonnegotiables and that which matters most, and then toss the excess. Only then, when our lives are clean slates and our commitments are what absolutely must and should remain, do we begin to institute rhythms and routines to help things run smoothly.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-2"
    }
  }, [_vm._v("I know how to simplify my schedule, and I can organize a pantry like nobody’s business, but this was new, deeper territory. What would it look like to reject modern social norms of living a constantly connected, overfull life and adopt a life that was a little less . . . and yet more? Could we turn down the noise a little? (I asked myself these questions as if I needed permission!) Could we slow our breathing a bit? What if we just sat still for a few minutes? Was it possible to settle into life in a way that was good, not grand? Could we intentionally seek out less? And was it okay to want that?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz25-3"
    }
  }, [_vm._v("I began to have this conversation quietly with friends, as if it were an idea so outlandish that it should be whispered, for fear that someone might overhear and I’d be labeled as an extremist, or worse, "), _c('em', [_vm._v("boring")]), _vm._v(". But what I realized as I talked to more and more people is that I wasn’t crazy. I was saying out loud what others were having a hard time expressing. They were tired, plain and simple. They were overwhelmed. And they weren’t happy. Everyone was trying to figure out how to take a breath. Life felt overly busy, fast, loud, and packed too full.")]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAlDS"
    }
  }, [_c('em', [_vm._v("What would it look like to reject modern")])]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pANRqO"
    }
  }, [_c('em', [_vm._v("social norms of living a constantly")])]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pAj6"
    }
  }, [_c('em', [_vm._v("connected, overfull life and adopt a life")])]), _vm._v(" "), _c('p', {
    staticClass: "left1",
    attrs: {
      "id": "pA9X"
    }
  }, [_c('em', [_vm._v("that was a little")]), _vm._v(" "), _c('b', [_vm._v("LESS")]), _c('em', [_vm._v(". . . and yet")]), _vm._v(" "), _c('b', [_vm._v("MORE?")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pAS3o"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "AS3o",
      "role": "presentation",
      "src": "images/himg-26-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz27-2"
    }
  }, [_vm._v("The more I talked to people, the more I became convinced that this type of life isn’t working for any of us anymore. But what "), _c('em', [_vm._v("would")]), _vm._v(" work? The opposite? Quitting every optional thing in our lives? Clearing our calendars completely? Perhaps. Or maybe the answer lay in some gray area in between. Whatever the solution to this overwhelm was, I set out to find it.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_04",
      "role": "doc-chapter",
      "title": "QUESTION EVERYTHING"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz27-3"
    }
  }, [_c('b', [_vm._v("QUESTION EVERYTHING")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz27-4"
    }
  }, [_vm._v("My first realization was enormous and foundational: our lives were not meant to include "), _c('em', [_vm._v("so much")]), _vm._v(". The contemporary world has inserted so many additional and new things into our lives (puffs into our balloons), which we have passively accepted as perks of modern life. Many of these advantages didn’t exist even a few years ago (social media, the internet, endless apps that can do anything and everything, to name a few), yet as humans, we still operate on the same level. We haven’t adapted or evolved for this kind of massive shift. Sounds and colors and notifications and information come at us from every angle at all hours of the day. No wonder we’re tired.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz27-5"
    }
  }, [_vm._v("Add overwhelm and worry regarding daily activities—both of which are constantly running in the background, silently draining our personal batteries—and it’s a recipe for disaster on both an individual and societal level.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz27-6"
    }
  }, [_vm._v("I decided I would begin by questioning everything:")]), _vm._v(" "), _c('ul', {
    staticClass: "ula",
    attrs: {
      "id": "ABW"
    }
  }, [_c('li', {
    attrs: {
      "id": "pz27-7"
    }
  }, [_vm._v("Can we have good friends without attending every party thrown?")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "AUQ"
    }
  }, [_vm._v("Can we raise children of character without nudging them into every sport or hobby they show an interest in?")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "AsI"
    }
  }, [_vm._v("Can we listen to stories on the way to school or work, instead of the news, and still be informed?")]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "Ayp"
    }
  }, [_vm._v("Can we disconnect from our phones and social media and still be connected?")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz28-7"
    }
  }, [_vm._v("I began to examine how many toys we owned and the types of play I was introducing to my children. I looked at the setup of our home. Did it encourage our family to relax and connect, or was it too perfectly picked up and uninviting? I began questioning chemicals in cleaning products, fillers in children’s snacks, and extra noise in our home. Digging deep into this topic became exhausting, so I created a manifesto for our family as a starting point. These statements would serve as guidelines for the decisions we make for ourselves, our home, and our children. As a place where we could begin to unwind and unravel years of adherence to what the world told us was right. In short, I wanted our family to live a life that was whole, good, and rich with meaning. And I was convinced that less of certain things would ultimately lead to more of what we all really want for our lives and our families: the slow, simple, and good moments worth cherishing and celebrating.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz28-8"
    }
  }, [_vm._v("When we choose a value or an object, we unknowingly are "), _c('span', {
    attrs: {
      "id": "z30-1"
    }
  }, [_vm._v("declining its opposite—even though the opposite may be the very thing we should be investing in or would lead to the outcome we most desire.")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pA_H"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "A_H",
      "role": "presentation",
      "src": "images/himg-29-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "pA9yc"
    }
  }, [_c('em', [_vm._v("Less rush, more rhythm")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "A5R"
    }
  }, [_c('em', [_vm._v("Less liking, more loving")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "AdAX"
    }
  }, [_c('em', [_vm._v("Less noise, more calm")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "A09"
    }
  }, [_c('em', [_vm._v("Less distraction, more connection")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "AAE"
    }
  }, [_c('em', [_vm._v("Less frenzy, more soul rest")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "Axl"
    }
  }, [_c('em', [_vm._v("Less fake, more real")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "AAp"
    }
  }, [_c('em', [_vm._v("Less fear, more community")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "A9A"
    }
  }, [_c('em', [_vm._v("Less great, more good")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "A-q"
    }
  }, [_c('em', [_vm._v("Less chasing, more cherishing")])]), _vm._v(" "), _c('p', {
    staticClass: "right2",
    attrs: {
      "id": "AKG"
    }
  }, [_c('em', [_vm._v("Less stuff, more treasures")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-2"
    }
  }, [_vm._v("For instance, when we select a toy that lights up and makes sounds and entertains, we are essentially "), _c('em', [_vm._v("not")]), _vm._v(" choosing a toy that is basic and more play-based that would stir our children’s imaginations. When we default to another night of dinner eaten on the run, we are saying no to a meal at home, however meager or simple it might be. When we spend hours scrolling through photos and updates from friends on social media, we are forgoing the undistracted time with our thoughts and with our people that would happen if we just put our phones down.")]), _vm._v(" "), _c('div', {
    staticClass: "box1"
  }, [_c('p', {
    staticClass: "hang1",
    attrs: {
      "id": "pAkf"
    }
  }, [_c('em', [_vm._v("We can say yes to a slower, simpler, quieter pace.")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz30-5"
    }
  }, [_vm._v("We can choose to say no to constantly rushing. We can say yes to a slower, simpler, quieter pace. When we opt for no radio in the car, we open the door for real conversation. When we say no to a second extracurricular activity, we pave the way for quality time with our kids, for rest, for refreshment.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_05",
      "role": "doc-chapter",
      "title": "YOU CAN SAY NO"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz30-6"
    }
  }, [_c('b', [_vm._v("YOU CAN SAY NO")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz30-7"
    }
  }, [_vm._v("The reality is that the world has changed and become more intense and fast-paced. We have allowed certain new "), _c('span', {
    attrs: {
      "id": "z31-1"
    }
  }, [_vm._v("complexities into our lives, further inflating our balloons. We have chosen to say yes to these things by not saying no. That’s scary if you really think about it. But this realization can also be liberating! We get to "), _c('em', [_vm._v("choose")]), _vm._v(" what we say yes to. And we get to "), _c('em', [_vm._v("choose")]), _vm._v(" what we say no to. We have the ability to make these choices based on our values, mindfully adding and subtracting to achieve the outcomes we most desire. While we can’t opt out of some responsibilities in our lives (going to work, parenting, paying our bills, etc.), there "), _c('em', [_vm._v("are")]), _vm._v(" some items on our plate we can say no to if we so choose. This realization excited me, and before I knew it, I was on a roll, questioning everything. The freedom that came with each small choice was infectious. And slowly, I felt the grip of overwhelm begin to loosen. Take a deep breath and walk through some examples with me:")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_01",
      "role": "doc-chapter",
      "title": "You do not need a Facebook or Instagram account."
    }
  }, [_c('h3', {
    attrs: {
      "id": "pz31-2"
    }
  }, [_c('b', [_c('i', [_vm._v("You do not need a Facebook or Instagram account.")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-3"
    }
  }, [_c('em', [_vm._v("Oh, but I do, Emily. I need it so I can keep in touch with friends who live far away. But I use it for my business. I use it to share photos of our children for our extended family so they can watch them grow.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz31-4"
    }
  }, [_vm._v("But do you "), _c('em', [_vm._v("really")]), _vm._v(" need to be on social media? Obviously, this choice isn’t black and white. But what if there’s a way to manage it differently that turns down the noise of social media just a bit? Options abound, such as scheduling business posts once a week or month, responding to questions and comments once a day, and limiting yourself to weekdays only.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-1"
    }
  }, [_vm._v("You do not have to accept that social media is a three- to four-hour-a-day activity (or distraction) in your life. If your day is a pie chart, you get to decide how large of a slice social media takes up. Sometimes distractions (like social media) actually make our days feel more rushed than they really are because our attention is being constantly drawn away from what’s happening right in front of us. It doesn’t have to be this way.")])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_02",
      "role": "doc-chapter",
      "title": "Your kids do not need to be in dozens of extracurricular activities."
    }
  }, [_c('h3', {
    attrs: {
      "id": "pz32-2"
    }
  }, [_c('b', [_c('i', [_vm._v("Your kids do not need to be in dozens of extracurricular activities.")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-3"
    }
  }, [_c('em', [_vm._v("Oh, but they do. My children are interested in so many things. I don’t want to stifle them. And you never know what interest might be “the one.”")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-4"
    }
  }, [_vm._v("But "), _c('em', [_vm._v("do")]), _vm._v(" they? Which activity do your kids love most? What would happen if their focus was no longer on several different activities but solely on school, on one extracurricular, and on family? Could you introduce your children to other activities at home? With more margin and focus to dedicate, would their imaginations blossom? Would their creativity skyrocket?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz32-5"
    }
  }, [_vm._v("In our home we’ve introduced “intentional boredom” (a very fancy term for taking away all the technology and shepherding our children into imaginative play). Embracing boredom in our home now paves the way for our kids to get creative: building forts out of pillows, crafting stuffed-animal homes out of cardboard boxes, or finding a sunny spot to read a book. This has decreased the rush of our week (with three kids, we now "), _c('span', {
    attrs: {
      "id": "z33-1"
    }
  }, [_vm._v("have three extracurricular activities per season) and increased imaginative play.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h3_03",
      "role": "doc-chapter",
      "title": "You do not need to be “that girl” who is always too busy for a coffee date with a special friend."
    }
  }, [_c('h3', {
    attrs: {
      "id": "pz33-2"
    }
  }, [_c('b', [_c('i', [_vm._v("You do not need to be “that girl” who is always too busy for a coffee date with a special friend.")])])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz33-3"
    }
  }, [_c('em', [_vm._v("Oh, but I")]), _vm._v(" am "), _c('em', [_vm._v("that girl! I have so much going on. My circumstances are what they are. I just have to keep going like I am. Work, kids, house, laundry, meetings, repeat.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz33-4"
    }
  }, [_vm._v("Trust me, I get it. But do you? Really? Are there ways you could add more rhythm and routine to the things on your plate you cannot remove? I’d venture to say that if you stopped and evaluated the hundreds of microcommitments surrounding your biggest commitments, you’d actually find quite a few things on your plate that you could adjust or say no to altogether.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz33-5"
    }
  }, [_vm._v("Adding rhythm to your life is actually a simple task. We decide the cadence at which we live. We can add milestones or markers to our weekly and daily schedules to set the cadence for ourselves and our families. Implementing a morning or evening routine, for example, gives children (especially) and adults a sense of safety and belonging. They know what will happen next . . . and then it does.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz33-6"
    }
  }, [_vm._v("The rest of the world may be frenzied and hurried, but inside the walls of our home, we follow a certain beat at night: dinner, cleanup, bath time, stories, prayers, bedtime. No evening routine is ever perfect, but this is the general goal. In the mornings we brush our teeth, get dressed, eat breakfast, clean up, and "), _c('span', {
    attrs: {
      "id": "z34-1"
    }
  }, [_vm._v("go to school. Our weeks are marked by fun, simple traditions like Taco Tuesdays and Pizza Party Fridays, as well as systems like chores, family values (posted for all to see), and rules for behavior understood by all.")])]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz34-2"
    }
  }, [_vm._v("These may seem like simple and obvious cornerstones of family life, but even as I write this, I can think of a few routines that could use either additional flexibility or structure in our own home. These ordinary routines and everyday occurrences are the "), _c('em', [_vm._v("good stuff")]), _vm._v(" of family life. And I can say firsthand that they are the first to be lost or sacrificed when the pace of life becomes too quick.")])])]), _vm._v(" "), _c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h2_06",
      "role": "doc-chapter",
      "title": "YOU CAN DO IT ALL . . . BUTSHOULDYOU?"
    }
  }, [_c('h2', {
    attrs: {
      "id": "pz34-3"
    }
  }, [_c('b', [_vm._v("YOU CAN DO IT ALL . . . BUT")]), _vm._v(" "), _c('i', [_c('b', [_vm._v("SHOULD")])]), _vm._v(" "), _c('b', [_vm._v("YOU?")])]), _vm._v(" "), _c('p', {
    staticClass: "noind",
    attrs: {
      "id": "pz34-4"
    }
  }, [_vm._v("We have a finite amount of focus and a finite amount of space in our brains. Neither of these is unlimited. "), _c('em', [_vm._v("This")]), _vm._v(" has been the single most revolutionary realization for me. You and the woman who existed a hundred years ago—before television and computers and the internet and smartphones and T-ball leagues and iCal—have the same mental capacity in your head. Her core focuses were different than yours are now, but she had a much smaller pile of things that required her daily thoughts and attention. You have hundreds, if not thousands, more.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz34-5"
    }
  }, [_vm._v("That space in your head and heart is sacred. Protect it as "), _c('span', {
    attrs: {
      "id": "AoW"
    }
  }, [_vm._v("holy, and allow in only what’s truly significant. This is where you must be brave. This is where it’s easy to get stuck. We can believe the lie that we must do things the way we always have. We can believe we are powerless in our circumstances and therefore powerless against a future as burned-out women.")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pAOvJ"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "AOvJ",
      "role": "presentation",
      "src": "images/himg-35-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "pAmK"
    }
  }, [_vm._v("Protect the space")]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "pAPG"
    }
  }, [_vm._v("in your head and heart")]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "pAR-"
    }
  }, [_vm._v("as "), _c('b', [_vm._v("HOLY")]), _vm._v(", and allow")]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "pAu7"
    }
  }, [_vm._v("only what’s truly")]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "AqZ"
    }
  }, [_vm._v("and specifically")]), _vm._v(" "), _c('p', {
    staticClass: "left2",
    attrs: {
      "id": "pA8q"
    }
  }, [_c('b', [_vm._v("SIGNIFICANT")]), _vm._v(" in.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAB8"
    }
  }, [_vm._v("Or we can believe that God made us for more.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pAUy"
    }
  }, [_vm._v("We can make choices that allow us to be women who have inner calm and outward joy. You were not created to be constantly overwhelmed. You were not created to function at max capacity day after day. You have not been forgotten. You are a daughter of the King, and you have the power to make choices about the way you live your life. You are precious and special and significant. You can opt for a life of less. You can say no to the world constantly telling you to be, do, and have more. You, like sweet Caroline, are capable of being a bright yellow balloon "), _c('em', [_vm._v("adequately")]), _vm._v(" full of "), _c('em', [_vm._v("goodness and joy")]), _vm._v(" whether you are four, fourteen, forty, or ninety-four. Destiny is a decision. So much in the world is out of control. But even if just a little we can manage what happens within the walls of our hearts and homes. This is holy work.")]), _vm._v(" "), _c('p', {
    staticClass: "center2",
    attrs: {
      "id": "pAstZ"
    }
  }, [_c('b', [_vm._v("Destiny "), _c('br'), _vm._v(" is a "), _c('br'), _vm._v(" decision")])]), _vm._v(" "), _c('div', {
    staticClass: "image1",
    attrs: {
      "id": "pz38-1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "id": "z38-1",
      "role": "presentation",
      "src": "images/himg-38-1.jpg"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba8ec1e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter02.vue
// module id = 84
// module chunks = 0